export default __webpack_public_path__ + "static/media/DrNotes-logo.efdeced3.png";